export default __webpack_public_path__ + "static/media/chevron-down-double.4a7b3bb2.svg";